export default "__VITE_ASSET__DcjsgPFF__"